/**
 * Get Global auth URL from Consul properties.
 * @param {string} [type] - empty or 'error'
 * @returns {string} Global auth url.
 */
const getAuthUrl = (type = '') => {
    const props = JSON.parse(localStorage.getItem('globalAuth'));
    const authUrl = props.url.baseUrl + props.url.returnUrlParam;

    if (type === 'error') {
        return authUrl + props.url.errorParam;
    }

    return authUrl;
}

/**
 * Open Global Auth page when called.
 * @param {string} [type] - empty or 'error'. 
 */
const openGlobalAuth = (type = '') => {
    const authUrl = getAuthUrl(type);
    window.location.replace(authUrl);
}

export default openGlobalAuth; 